import { ArrowCircleDown as r } from "./arrow-circle-down.js";
import { ArrowCircleUp as o } from "./arrow-circle-up.js";
import { ArrowCircleUpFilled as m } from "./arrow-circle-up-filled.js";
import { ArrowCircleDownFilled as i } from "./arrow-circle-down-filled.js";
import { ArrowLeft as t } from "./arrow-left.js";
import { ArrowCircleLeft as p } from "./arrow-circle-left.js";
import { ArrowCircleLeftFilled as f } from "./arrow-circle-left-filled.js";
import { ArrowCircleRight as e } from "./arrow-circle-right.js";
import { ArrowCircleRightFilled as l } from "./arrow-circle-right-filled.js";
import { ArrowLeftRight as n } from "./arrow-left-right.js";
import { ArrowRight as a } from "./arrow-right.js";
import { ArrowTop as w } from "./arrow-top.js";
import { ArrowBottom as h } from "./arrow-bottom.js";
import { ArrowTopSmall as g } from "./arrow-top-small.js";
import { ArrowBottomSmall as A } from "./arrow-bottom-small.js";
import { ChevronsUp as S } from "./chevrons-up.js";
import { ChevronsDown as C } from "./chevrons-down.js";
import { ChevronUp as R } from "./chevron-up.js";
import { ChevronsLeft as c } from "./chevrons-left.js";
import { ChevronsRight as d } from "./chevrons-right.js";
import { ChevronDown as L } from "./chevron-down.js";
import { ChevronLeft as s } from "./chevron-left.js";
import { ChevronRight as v } from "./chevron-right.js";
import { ChevronUpSmall as D } from "./chevron-up-small.js";
import { ChevronDownSmall as U } from "./chevron-down-small.js";
import { ChevronLeftSmall as u } from "./chevron-left-small.js";
import { ChevronRightSmall as T } from "./chevron-right-small.js";
import { Download as x } from "./download.js";
import { Refresh as E } from "./refresh.js";
import { RefreshSmall as k } from "./refresh-small.js";
import { ExternalLink as F } from "./external-link.js";
import { ExternalLinkSmall as y } from "./external-link-small.js";
import { ArrowDiagonalDownSmall as B } from "./arrow-diagonal-down-small.js";
import { RefreshSmallSquareFilled as q } from "./refresh-small-square-filled.js";
import { Recurring2 as I } from "./recurring-2.js";
import { Expand as N } from "./expand.js";
import { Collapse as z } from "./collapse.js";
import { ExpandVertically as H } from "./expand-vertically.js";
import { ArrowDiagonalDown as K } from "./arrow-diagonal-down.js";
import { LoadingSmall as M } from "./loading-small.js";
import { LoadingLines as V } from "./loading-lines.js";
import { TurnLeft as b } from "./turn-left.js";
import { TurnRight as j } from "./turn-right.js";
import { SkipUp as G } from "./skip-up.js";
import { SkipDown as J } from "./skip-down.js";
import { SkipLeft as O } from "./skip-left.js";
import { SkipRight as P } from "./skip-right.js";
import { Size as Q } from "./size.js";
import { UpDown as W } from "./up-down.js";
import { AccountSwitch as X } from "./account-switch.js";
import { Move as Y } from "./move.js";
import { EnterKey as Z } from "./enter-key.js";
import { Inheritance as _ } from "./inheritance.js";
import { Share1 as $ } from "./share-1.js";
import { Exit as rr } from "./exit.js";
import { Upload as or } from "./upload.js";
import { NavigationExpand as mr } from "./navigation-expand.js";
import { NavigationCollapse as ir } from "./navigation-collapse.js";
import { TriangleUp as tr } from "./triangle-up.js";
import { TriangleDown as pr } from "./triangle-down.js";
import { TriangleLeft as fr } from "./triangle-left.js";
import { TriangleRight as er } from "./triangle-right.js";
import { RefreshSmallSquare as lr } from "./refresh-small-square.js";
import { AngledRight as nr } from "./angled-right.js";
import { AngledLeft as ar } from "./angled-left.js";
import { ArrowRightSmall as wr } from "./arrow-right-small.js";
import { ArrowRightLeftRound as hr } from "./arrow-right-left-round.js";
import { ArrowTopBottom as gr } from "./arrow-top-bottom.js";
import { ArrowUpDownSort as Ar } from "./arrow-up-down-sort.js";
import { History as Sr } from "./history.js";
import { Inheritence as Cr } from "./inheritence.js";
import { Recurring as Rr } from "./recurring.js";
import { Refund as cr } from "./refund.js";
import { SortAscending as dr } from "./sort-ascending.js";
import { SortDescending as Lr } from "./sort-descending.js";
const Go = {
  ArrowCircleDown: r,
  ArrowCircleUp: o,
  ArrowCircleUpFilled: m,
  ArrowCircleDownFilled: i,
  ArrowLeft: t,
  ArrowCircleLeft: p,
  ArrowCircleLeftFilled: f,
  ArrowCircleRight: e,
  ArrowCircleRightFilled: l,
  ArrowLeftRight: n,
  ArrowRight: a,
  ArrowTop: w,
  ArrowBottom: h,
  ArrowTopSmall: g,
  ArrowBottomSmall: A,
  ChevronsUp: S,
  ChevronsDown: C,
  ChevronUp: R,
  ChevronsLeft: c,
  ChevronsRight: d,
  ChevronDown: L,
  ChevronLeft: s,
  ChevronRight: v,
  ChevronUpSmall: D,
  ChevronDownSmall: U,
  ChevronLeftSmall: u,
  ChevronRightSmall: T,
  Download: x,
  Refresh: E,
  RefreshSmall: k,
  ExternalLink: F,
  ExternalLinkSmall: y,
  ArrowDiagonalDownSmall: B,
  RefreshSmallSquareFilled: q,
  Recurring2: I,
  Expand: N,
  Collapse: z,
  ExpandVertically: H,
  ArrowDiagonalDown: K,
  LoadingSmall: M,
  LoadingLines: V,
  TurnLeft: b,
  TurnRight: j,
  SkipUp: G,
  SkipDown: J,
  SkipLeft: O,
  SkipRight: P,
  Size: Q,
  UpDown: W,
  AccountSwitch: X,
  Move: Y,
  EnterKey: Z,
  Inheritance: _,
  Share1: $,
  Exit: rr,
  Upload: or,
  NavigationExpand: mr,
  NavigationCollapse: ir,
  TriangleUp: tr,
  TriangleDown: pr,
  TriangleLeft: fr,
  TriangleRight: er,
  RefreshSmallSquare: lr,
  AngledRight: nr,
  AngledLeft: ar,
  ArrowRightSmall: wr,
  ArrowRightLeftRound: hr,
  ArrowTopBottom: gr,
  ArrowUpDownSort: Ar,
  History: Sr,
  Inheritence: Cr,
  Recurring: Rr,
  Refund: cr,
  SortAscending: dr,
  SortDescending: Lr
};
export {
  Go as Arrows
};
